import { DateTime } from "luxon";
import SuperJSON from "superjson";

SuperJSON.registerCustom<DateTime, string>(
  {
    isApplicable: (v): v is DateTime => {
      return DateTime.isDateTime(v);
    },
    serialize: (v) => v.toJSON() ?? "",
    deserialize: (v) => DateTime.fromISO(v),
  },
  "luxon",
);

export { SuperJSON as MyJSONSerializer };
